import initialState from "./initialState";
import {SET_AUTH_CRED} from "../actions/AuthActions";

export default function AuthReducer(state = initialState.auth, action) {
    switch (action.type) {
        case SET_AUTH_CRED:
            const {data} = action.payload;
            return {...data};
        default:
            return state;
    }
}
